import { useSearchParams } from "react-router-dom";
import { PillTabs } from "../components/lux";
import { useAuth } from "../contexts/AuthContext";
import TodayView from "../components/dashboard/TodayView";
import NumbersView from "../components/dashboard/NumbersView";

// DASH-002: two tabs. Today (default) is built from access + links. Numbers
// holds the period figures from DASH-001 and is shown only to accounts that
// have something in it — an admin, or a login with Sales Performance.
export default function Dashboard() {
  const { user } = useAuth();
  const showNumbers = user?.role === "admin" || (user?.permissions || []).includes("sales_performance");

  const [params, setParams] = useSearchParams();
  const tabParam = params.get("tab");
  const tab = showNumbers && tabParam === "numbers" ? "numbers" : "today";
  const changeTab = (val) => {
    const next = new URLSearchParams(params);
    if (val === "today") next.delete("tab");
    else next.set("tab", val);
    setParams(next, { replace: true });
  };

  const tabs = [{ key: "today", label: "Today" }];
  if (showNumbers) tabs.push({ key: "numbers", label: "Numbers" });

  return (
    <div className="space-y-6" data-testid="dashboard">
      {showNumbers && <PillTabs tabs={tabs} value={tab} onChange={changeTab} testid="dashboard-tabs" />}
      {tab === "numbers" ? <NumbersView /> : <TodayView />}
    </div>
  );
}
